// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"7db7f992","706":"9ae0496c"}[chunkId] + ".chunk.js";
};